import React from 'react';
import ClusterMultiSelect from 'app/components/ClusterMultiSelect';

import { useBulkPlaybookUpdateTableContext } from 'ion-experimental/app/bulk-playbook-update/BulkPlaybookUpdateTableContext';

export default function BulkPlaybookUpdateClusterMultiSelect() {
  const { setSelectedClusters } = useBulkPlaybookUpdateTableContext();

  return (
    <ClusterMultiSelect
      setSelectedClusters={setSelectedClusters}
      renderValue={selected => `Clusters (${selected.length})`}
      data-test-id="clusterMultiSelect"
    />
  );
}
